import React, { Component } from 'react';
import { connect } from 'react-redux'
import HeaderLogo from '../../images/headerLogo'
import T from 'i18n-react';
import AuthActions from '../../store/authRedux'

class Unauthorized extends Component {
    constructor(props) {
        super(props);

       

        this.logoutType = 'normal'

        this.state = {
            lang: this.props.lang,  
            isloading: false
        }
       
    }       

    componentWillReceiveProps(newProps) {
        if (this.state.lang !== newProps.lang) {
            this.setState({ lang: newProps.lang })
        }
    }

    onSignOutClick = (e) => {
        this.props.logoutUser()
    }

    render() {       
       
        var buttonLabel = 'Inactivity.SignOutButton'

        return (
            <div>
                <div style={{ top: '-70px', position: 'relative' }} ><hr style={{ display: 'block', height: '1px', border: '0', borderTop: '1px solid #E4E4E4' }} /></div>                
                    <div className="logoutOuter">
                        <div className="logoutBox" >
                            <div className="logoutLogoHolder">
                                <HeaderLogo lang={'en'} darkText={true} width={"250px"} />
                            </div>
                            <p className="unauthorized_center_content_bold" >
                                <span key='logoutcontent1'>{T.translate('Unauthorized.Message1')}</span>
                                <span key='logoutcontent2'>{T.translate('Unauthorized.Message2')}</span>
                            </p>
                            <div className="unauthorized_center_content" key='logoutcontent3'>{T.translate('Unauthorized.Message3')}</div>
                            <button onClick={this.onSignOutClick} className="button is-link is-fullwidth">
                                <span>{T.translate(buttonLabel)}</span>
                            </button>
                        </div>
                    </div>                
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lang: state.layout.lang
    }
}

const mapDispatchToProps = (dispatch) => ({
    logoutUser: () => dispatch(AuthActions.logoutUser())
})

export default connect(mapStateToProps, mapDispatchToProps)(Unauthorized)